// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".page-hero[data-v-50caf954]{background-position:top}.page-hero[data-v-50caf954]:before{content:\"\";display:block;position:absolute;top:0;left:0;width:100%;height:100%;background:transparent linear-gradient(180deg,rgba(0,128,199,.6784313725),rgba(0,128,199,0)) 0 0 no-repeat padding-box}", ""]);
// Exports
module.exports = exports;
